import Skeleton from "antd/es/skeleton"
import { ArrowRight, ListTodo } from "lucide-react"
import { Link } from "react-router"

interface Props {
  items: { title: string; questions: number; url: string }[]
  loading: boolean
}

const QuestionnaireReviewTile: React.FC<Props> = ({ items, loading }) => {
  const itemElements = items.slice(0, 20).map((item, index) => (
    <Link
      to={item.url}
      key={index}
      className="bg-gray-25 mb-2 flex cursor-pointer items-center justify-between rounded-md p-2 text-sm font-medium hover:bg-gray-50"
    >
      <div>
        <div className="text-primary">{item.title}</div>
        <span className="text-gray-400">{item.questions} questions</span>
      </div>
      <div>
        <ArrowRight size={18} className="text-primary" />
      </div>
    </Link>
  ))
  return (
    <div className="mt-6 flex flex-1 grow flex-col gap-4 overflow-y-auto md:flex-row">
      <div className="flex-grow rounded-2xl border border-gray-100 p-6">
        <div className="flex items-center text-sm font-bold text-gray-400">
          <ListTodo className="mr-2" size={18} />{" "}
          <div>Questionnaire Assistant</div>
        </div>
        <h3 className="mb-4 text-lg font-semibold">
          Questionnaires Ready for Review
        </h3>
        <Skeleton active loading={loading}>
          <div className="mb-4 text-7xl">{items.length}</div>
          {itemElements}
          {items.length > 20 && (
            <Link
              to="/questionnaire-assistant"
              className="text-primary font-medium"
            >
              View all
            </Link>
          )}
        </Skeleton>
      </div>
    </div>
  )
}

export default QuestionnaireReviewTile
